import type { FaireProductEntity } from "../../entity_types/product";

export const p_fwtqyquezx: FaireProductEntity = {
  token: "p_fwtqyquezx",
  type: "product",
  name: "The Cumin Club Vindaloo Sauce",
  brandToken: "b_hzc2pb2q9s",
  brandName: "The Cumin Club",
  imageUrl:
    "https://cdn.faire.com/fastly/3303daab9e125aefc40a7e969569e80999141c0e832c86bc174f7cdb306a52c8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a021fdfbf9cd9d575c085a43065a428f180c6c7bfa0495afaa23d1c7fcf449c8.png",
    "https://cdn.faire.com/fastly/3054ef6a32c6ed683200a5086831b4d80180e83c39a67715b5756588e1e47a8b.jpeg",
  ],
  priceDollars: 3.99,
  description:
    "The Cumin Club Vindaloo Sauce is a bold and flavorful blend inspired by the classic Goan dish. Crafted with tangy tamarind, coconut milk, and a mix of roasted spices, this sauce brings the perfect balance of heat and tang. Just add water and simmer with your favorite protein or vegetables for a vibrant, restaurant-style curry at home.\n\nProduct Highlights\n\n\t\t• 5-Minute Cooking – just add water and cook, then add your favorite protein or vegetables\n\t\t• All-Natural Ingredients – no preservatives, no seed oils\n\t\t• Crafted by Expert Chefs – using locally sourced, high-quality ingredients and traditional recipes",
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:24.317Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
